module.exports = __webpack_public_path__ + "static/media/premio-2022.8a612364.jpg";